<script>

    import throttle from 'just-throttle';

    export let breakpoint = 720;
    export let layout = 'mobile'; // (desktop|mobile)

    function update(){
        let l = window.innerWidth <= breakpoint ? 'mobile' : 'desktop';
        if( l !== layout ){
            layout = l;
        }
    }
    update();

</script>

<svelte:window on:resize={()=>throttle(() => update(), 100, {leading: true})} />

{#if layout == 'mobile'}

    <slot name="mobile" />

{:else if layout == 'desktop'}
    
    <slot name="desktop" />
    
{/if}